import * as React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { observer } from 'mobx-react';

import { MenuBurgerIcon } from 'shared/newComponents/icons';
import Logo from 'shared/newComponents/Logo';
import { IconStyle } from 'shared/entities/components/Icon';
import { ComponentType } from 'shared/entities/components/Component';
import { usePageTemplateMenuStore } from 'stores/PageTemplateMenuStore';

import MobileHeader from './MobileHeader';

import './Header.modules.scss';

type Props = {
  onBurgerClick: () => void;
  className?: string;
};

const Header: React.FC<Props> = ({ onBurgerClick, className }) => {
  const menuStore = usePageTemplateMenuStore();

  const showLeft = menuStore.isMenuOpened || menuStore.isMobileMenu;
  const menuClosedOnMobile = menuStore.isMobileMenu && !menuStore.isMenuOpened;

  return (
    <div styleName="header" className={className}>
      <AnimatePresence>
        {showLeft && (
          <motion.div
            styleName="header__left"
            animate={{ opacity: 1 }}
            initial={{ opacity: 0 }}
            transition={{ ease: 'easeInOut' }}
          >
            {menuClosedOnMobile ? <MobileHeader /> : <Logo />}
          </motion.div>
        )}
      </AnimatePresence>
      <MenuBurgerIcon
        action={{
          type: ComponentType.svg,
          onClick: onBurgerClick
        }}
        iconStyle={IconStyle.gray}
        styleName="header__right"
      />
    </div>
  );
};

export default observer(Header);
